import { client } from './client'

// リトライ可能なエラーかどうかを判定
const isRetryableError = (error) => {
  // ネットワークエラー（iOS Safari対応）
  if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
    return true
  }
  // 5xxサーバーエラー（502 Bad Gateway, 503 Service Unavailable, 504 Gateway Timeout等）
  if (error.response && error.response.status >= 500 && error.response.status < 600) {
    return true
  }
  return false
}

// リトライ機能付きAPI呼び出し
export const getCount = async (params, retryCount = 0) => {
  const maxRetries = 3
  const retryDelay = 1000 // 1秒

  try {
    const response = await client.get('/api/nursing_facilities/count/', { params })
    const data = response.data
    return data
  } catch (error) {
    // リトライ可能なエラーの場合
    if (isRetryableError(error) && retryCount < maxRetries) {
      const errorType = error.response ? `HTTP ${error.response.status}` : error.code || 'Network Error'
      console.warn(`API Error (${errorType}) - Retrying ${retryCount + 1}/${maxRetries}:`, error.config?.url)

      // リトライ前に待機（線形バックオフ: 1秒、2秒、3秒）
      await new Promise(resolve => setTimeout(resolve, retryDelay * (retryCount + 1)))

      return getCount(params, retryCount + 1)
    }

    // 最大リトライ回数に達した場合、またはリトライ不可能なエラーの場合は再スロー
    throw error
  }
}
